'use client';

import type { ReactNode } from 'react';
import type { Theme } from '@kausal/themes/types';
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import { CommonThemeProvider } from '@common/providers/CommonThemeProvider';
type Props = {
  theme: Theme;
  children: ReactNode;
};
export default function ThemeProvider({
  theme,
  children
}: Props) {
  return <SCThemeProvider theme={theme} data-sentry-element="SCThemeProvider" data-sentry-component="ThemeProvider" data-sentry-source-file="ThemeProvider.tsx">
      <CommonThemeProvider theme={theme} data-sentry-element="CommonThemeProvider" data-sentry-source-file="ThemeProvider.tsx">{children}</CommonThemeProvider>
    </SCThemeProvider>;
}